import React, { Component } from 'react';
import EmailFormTemp from '../temps/EmailFormTemp';


class AboutUs extends Component {
//org state
    state = {
        userId: '',
        user: '',
        hashPass: '',
        review: '',
        itemID: '',
        errors: [],
    }
    //mounts after
    componentDidMount() {
        const { context } = this.props;
        const auth = context.authenticatedUser
        const hashPass = context.hashPass
        console.log(hashPass)
        if(auth) {
        console.log(auth)
           this.setState({
            userId: auth.id,
            user: auth,
            hashPass: hashPass,

        })
    }
    }



    //page
    render() {
        const {
            itemID,
            review,
            errors
        } = this.state;





        return (
            <div>

            <div className="bounds ">

                <div style={{textAlign: "center", zIndex: -1}} className="grid-33 centered bg-dark">



                    <div style={styles.about}>
                    <div style={{display: 'inline-flex'}}>
                        </div>
                        <h1 className='text-warning' style={{marginTop: '3em', marginBottom: '2em'}}>Make A Review</h1>
                        <EmailFormTemp
                            back={this.back}
                            errors={errors}
                            elements={() => (
                                <React.Fragment>
                                    <div style={{display: 'inline-grid',width: "70%", textAlign: 'center'}}>   
                                        <input type="text"  name="name" placeholder="shoot us a text..." style={styles.emailText} required className='bg-dark text-warning'/>
                                        <input type="hidden" name="_next" value="https://main--reliable-clafoutis-97c21e.netlify.app/" />
                                        <input type="email"  name="email" placeholder="email Address..." style={styles.emailBox} className='bg-dark text-warning' required/>
                                        <input type="text"  name="item" placeholder="item Name..." style={styles.emailBox} className='bg-dark text-warning' required/>  
                                    </div>
                                </React.Fragment>
                            )} />
                    </div>

                </div>
            </div>
            </div>
        );
    }

    change = (event) => {
        const name = event.target.name;
        const value = event.target.value;

        this.setState(() => {
            return {
                [name]: value
            };
        });
    }


      //cancel to route
    back = () => {
        this.props.history.push('/');
    }
}

//styles
const styles = {
    linkDiv: {
        backgroundColor: "#3D3D3D",
        width: '100%',
        textDecoration: "none",
        margin: 25,
        alignItems: "center",
        display: 'inline-flex',
        height: "150px",
    },
    title: {
        position: 'relative',
        bottom: '25%',
        left: '2%',
    },
    emailBox: {
        border: 'solid 5px #3D3D3D',
        borderRadius: '8px',
       position:'relative',
       marginTop: "5%",
        marginBottom: "0%",
        width: "30%"
    },
    emailText: {
        border: 'solid 5px #3D3D3D',
        borderRadius: '8px',
       position:'relative',
       height: '20em',
       maxHeight: '20em',
       zIndex: 2,
    },
    about: {
        backgroundColor: "#3D3D3D",
        display: 'inline-block',
        width: '75%',
        marginX: '7%',
        height: '62em', 
        padding: '25px',
        textAlign: 'center',
        zIndex: -1,
      },

}



export default AboutUs